import { cx } from '@linaria/core';
import { useState, useEffect } from 'react';
import { FORMAT_SIZE_IN_MM } from '../constants.js';
import { Page } from './comp.page.js';
import { section } from './comp.section.style.js';
import { tokens, pxToMMConversionCls } from './shared.size-tokens.style.js';
import { jsx } from 'react/jsx-runtime';

function Section(props) {
  const [pageToPhysicalPageMapping, setMapping] = useState(new Array(props.section.pages.length).fill(undefined));
  const hasPhysicalContextData = pageToPhysicalPageMapping.every(it => typeof it === "number");
  const physicalSize = FORMAT_SIZE_IN_MM[props.format];
  const designAspectRatio = props.section.config.designSizeInPx.width / props.section.config.designSizeInPx.height;
  const physicalAspectRatio = physicalSize.width / physicalSize.height;
  if (Math.abs(designAspectRatio - physicalAspectRatio) > 0.005) {
    console.warn("populatePrintTarget.Section: Provided designSize aspectRatio does not match provided format!", props.format, props.section.config.designSizeInPx, physicalSize);
  }
  const onPhysicalPageRenderComplete = (pageIndexInSection, amountOfPhysicalPagesInPrintPage) => {
    setMapping(prev => {
      const next = [...prev];
      next[pageIndexInSection] = amountOfPhysicalPagesInPrintPage;
      return next;
    });
  };
  useEffect(() => {
    if (hasPhysicalContextData) {
      props.onPhsyicalPagesRenderedInSection(props.virtualContext.sectionIndex, pageToPhysicalPageMapping.reduce((acc, curr) => acc + curr, 0));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPhysicalContextData]);
  return /*#__PURE__*/jsx("div", {
    className: cx(section, pxToMMConversionCls),
    style: tokens.__override({
      designHeightInPx: props.section.config.designSizeInPx.height,
      designWidthInPx: props.section.config.designSizeInPx.width,
      physicalPageHeightInMM: physicalSize.height,
      physicalPageWidthInMM: physicalSize.width
    }),
    children: props.section.pages.map((it, index) => {
      const virtualContext = {
        currentPageIndexInSection: index,
        currentPageIndexInDocument: index + props.virtualContext.startPageIndex,
        pagesInDocument: props.virtualContext.pagesInDocument,
        pagesInCurrentSection: props.section.pages.length,
        currentSectionIndex: props.virtualContext.sectionIndex,
        sectionsInDocument: props.virtualContext.sectionsInDocument
      };
      const indexInSection = pageToPhysicalPageMapping.slice(0, index).reduce((acc, curr) => acc + curr, 0);
      const physicalContext = hasPhysicalContextData && props.physicalContext ? {
        currentPageIndexInSection: indexInSection,
        currentPageIndexInDocument: indexInSection + props.physicalContext.startPageIndex,
        pagesInDocument: props.physicalContext.pagesInDocument,
        pagesInCurrentSection: pageToPhysicalPageMapping.reduce((acc, curr) => acc + curr, 0),
        currentSectionIndex: props.physicalContext.sectionIndex,
        sectionsInDocument: props.physicalContext.sectionsInDocument
      } : undefined;
      return /*#__PURE__*/jsx(Page, {
        target: props.target,
        config: props.section.config,
        page: it,
        context: {
          virtual: virtualContext,
          physical: physicalContext
        },
        onPhysicalPagesRendered: onPhysicalPageRenderComplete
      }, index);
    })
  });
}

export { Section };
//# sourceMappingURL=comp.section.js.map
